module.exports = __webpack_public_path__ + "static/media/Deer_meat.c9d34dec.png";